const state = {
    error:[]
}

const getters = {
    /**
     * エラーの状態を取得
     * @param {Object} state 
     */
    getError(state) {
        return state.error
    }
}

const actions = {
    /**
     * エラーを追加する
     * @param {String} data 
     */
    addError({commit}, data) {
        commit('addError', data)
    },
    /**
     * エラーの内容を削除する
     */
    clearError({commit}) {
        commit('clearError')
    }
}

const mutations =  {
    /**
     * エラーを追加する
     * @param {String} n 
     */
    addError(state,n) {
        state.error.push(n)
    },
    /**
     * エラーの内容を削除する
     */
    clearError(state) {
        state.error = []
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}